import axiosPost from "./axiosPost";

export const SFHabitacionDel = async (credentials, data) => {
    const body = {
        service: "SFHabitacionDel",
        params: {
            SFHabitacionId: data.SFHabitacionId,
        },
    };

    const result = await axiosPost(body, credentials);
    if (result?.status?.code === 0) {
        return [result.status];
    }
    return result.result;
};
